import script from "./CompraMembresia.vue?vue&type=script&setup=true&lang=js"
export * from "./CompraMembresia.vue?vue&type=script&setup=true&lang=js"

import "./CompraMembresia.vue?vue&type=style&index=0&id=5566f336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5566f336"]])

export default __exports__